window.addEventListener("DOMContentLoaded", cartControllProcess);

/**
 * カートページ全体処理
 */
function cartControllProcess() {
  const prefSelectBox = document.getElementById("pref_select"); //都道府県選択用セレクトボックス
  const citySelectBox = document.getElementById("area_select"); //市区選択用セレクトボックス
  const checkBoxes = document.querySelectorAll(".cart-checkbox"); //チェックボックス(配列)
  const cartButton = document.querySelector(".cart-recap__checkout"); // カートボタン要素
  const quantitySelectors = document.querySelectorAll(".quantity-selector__button"); //数量変更ボタン（配列）
  const quantityBoxes = document.querySelectorAll(".quantity-selector__value"); //数量変更ボックス(配列)
  const noteToggleButton = document.querySelector(".cart-recap__note-button"); //注文メモ トグルボタン
  const note = document.getElementById("order-note"); //注文メモ
  const alertText = document.querySelector(".cart-recap .input_error"); //アラートテキスト

  changeSelectArea(prefSelectBox.value, citySelectBox); //選択可能な市区エリアを変更(初期化)

  let isReachPurchasePrice = false; //購入可能金額に届いているか否か

  noteToggleButton.setAttribute("aria-expanded", "true"); //注文メモを開いている状態に
  note.style.overflow = "visible";
  note.style.height = "auto";

  //settionStrageに格納したselect,input情報を各要素に代入
  if (sessionStorage.getItem("prefecture") !== null) {
    prefSelectBox.value = sessionStorage.getItem("prefecture");
    removeSpanElement(citySelectBox); //選択市区エリアのoptionの親要素からspanを削除する(SP対策)

    changeSelectArea(prefSelectBox.value, citySelectBox); //選択可能な市区エリアを変更
    citySelectBox.value = sessionStorage.getItem("city");
    isReachPurchasePrice = changeSelectInfo(prefSelectBox, citySelectBox); //選択情報表示エリアの内容変更
    dispSelectInfo(citySelectBox); //選択情報表示エリアだし分け

    checkBoxes.forEach((checkbox, index) => {
      const storedStatus = sessionStorage.getItem(`checkbox${index}`);
      if (storedStatus === "true") {
        checkbox.checked = true;
      }
    });
    checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton); //カートボタン制御
  } else {
    cartButton.disabled = true; //カートボタン非活性化
    alertText.style.visibility = "visible"; //アラート表示
  }

  //県エリアセレクト変更時
  prefSelectBox.addEventListener("change", () => {
    cartButton.disabled = true; //カートボタン非活性化
    alertText.style.visibility = "visible"; //アラート表示
    isReachPurchasePrice = false;
    removeSpanElement(citySelectBox); //選択市区エリアのoptionの親要素からspanを削除する(SP対策)
    changeSelectArea(prefSelectBox.value, citySelectBox); //選択市区エリア変更
    dispSelectInfo(citySelectBox); //金額表示エリアだし分け
  });

  //市区エリアセレクト変更時
  citySelectBox.addEventListener("change", () => {
    isReachPurchasePrice = changeSelectInfo(prefSelectBox, citySelectBox); //選択情報表示エリアの内容変更
    dispSelectInfo(citySelectBox); //選択情報表示エリアだし分け
    checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton); //カートボタン制御
  });

  // チェックボックスの状態変更時
  checkBoxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton); //カートボタン制御
    });
  });

  //数量変更ボタン押下時
  quantitySelectors.forEach((quantitySelector) => {
    quantitySelector.addEventListener("click", () => {
      cartButtonDisabled(); //カートボタン非活性化
      registerForSettionStorage(prefSelectBox, citySelectBox, checkBoxes); //input、selectボックスの情報をsessionStorageに格納
      pageReload(); //ページ再読み込み
    });
  });

  //数量変更ボックス入力時
  quantityBoxes.forEach((quantityBox) => {
    quantityBox.addEventListener("change", () => {
      cartButtonDisabled(); //カートボタン非活性化
      registerForSettionStorage(prefSelectBox, citySelectBox, checkBoxes); //input、selectボックスの情報をsessionStorageに格納
      pageReload(); //ページ再読み込み
    });
  });

  // 削除ボタン押下時
  document.querySelectorAll('.line-item__quantity-remove').forEach((removeButton) => {
    removeButton.addEventListener('click', () => {
      cartButtonDisabled(); //カートボタン非活性化
      registerForSettionStorage(prefSelectBox, citySelectBox, checkBoxes); //input、selectボックスの情報をsessionStorageに格納
      pageReload(); //ページ再読み込み
    });
  });

  // お届け日時変更時
  document.getElementById('deliver_date').addEventListener('change', () => {
    checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton); //カートボタン制御
  });
  document.getElementById('deliver_time').addEventListener('change', () => {
    checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton); //カートボタン制御
  });

  //カートボタン押下時
  cartButton.addEventListener("click", () => {
    registerForSettionStorage(prefSelectBox, citySelectBox, checkBoxes); //input、selectボックスの情報をsessionStorageに格納
  });
}

//市区オプションの親要素にspanが入っている場合は、spanを削除する
function removeSpanElement(citySelectBox) {
  const cityOptionsArray = Array.from(citySelectBox.children); //市区オプション一覧配列

  cityOptionsArray.forEach((areaOption) => {
    if(areaOption.tagName === "SPAN") {
      const optionElement = areaOption.firstChild;
      areaOption.parentNode.insertBefore(optionElement, areaOption);
      areaOption.parentNode.removeChild(areaOption);
      optionElement.hidden = false;
    }
  });
}

//選択した県ごとに、選択可能なエリアを変更する
function changeSelectArea(prefecture, citySelectBox) {
  const cityOptionsArray = Array.from(citySelectBox.children); //市区オプション一覧配列

  citySelectBox.value = "area";
  cityOptionsArray.forEach((areaOption) => {
    // if (areaOption.dataset.prefecture === prefecture) {
    //   areaOption.style.display = "block";
    // } else {
    //   areaOption.style.display = "none";
    // }
    console.log('areaOption',areaOption);
    if (areaOption.value !== "area" && areaOption.dataset.prefecture !== prefecture ) {
      const spanElement = document.createElement('span');
      spanElement.className = 'selector-hide';
      areaOption.parentNode.replaceChild(spanElement, areaOption);
      spanElement.appendChild(areaOption);
      areaOption.hidden = true;
    }
  });
}
// function changeSelectArea(prefecture, citySelectBox) {
//   const cityOptionsArray = Array.from(citySelectBox.options);

//   // console.clear();
//   // console.log("=== changeSelectArea START ===");
//   // console.log("選択された都道府県:", prefecture);

//   citySelectBox.value = "area";

//   cityOptionsArray.forEach((areaOption, idx) => {
//     // console.log(
//     //   `${idx}: value=${areaOption.value}, data-prefecture=${areaOption.dataset.prefecture}`
//     // );

//     if (areaOption.value === "area") {
//       areaOption.hidden = false;
//       // console.log(" -> デフォルト[エリア]は表示");
//       return;
//     }

//     if (areaOption.dataset.prefecture === prefecture) {
//       areaOption.hidden = false;
//       // console.log(" -> 表示対象");
//     } else {
//       areaOption.hidden = true;
//       // console.log(" -> 非表示対象");
//     }
//   });

//   // console.log("=== changeSelectArea END ===");
// }



//選択情報表示エリア表示、非表示切り替え
function dispSelectInfo(citySelectBox) {
  const selectInfoArea = document.getElementById("select_info");

  if (citySelectBox.value !== "area") {
    selectInfoArea.style.display = "block";
  } else {
    selectInfoArea.style.display = "none";
  }
}

//選択情報表示エリアの情報を変更
function changeSelectInfo(prefSelectBox, citySelectBox) {
  const dispPrefectureArea = document.getElementById("select_prefecture");
  const dispCityArea = document.getElementById("select_city");
  const dispMinPriceArea = document.getElementById("selected_city_minPrice");
  const dispRemainPriceArea = document.getElementById("remain_price");
  const remainPriceText = document.getElementById("remain_price_text");
  const minPrice = citySelectBox.options[citySelectBox.selectedIndex].dataset.minprice;
  const cartTotalSum = document
    .querySelector(".cart-recap__price-line-price.total-price")
    .textContent.split("")
    .filter((char) => !isNaN(char))
    .join(""); //合計金額

  dispPrefectureArea.innerText = prefSelectBox.options[prefSelectBox.selectedIndex].text;
  dispCityArea.innerText = citySelectBox.options[citySelectBox.selectedIndex].text;

  dispMinPriceArea.innerText = new Intl.NumberFormat("ja-JP").format(parseInt(minPrice)) + "円";
  dispRemainPriceArea.innerText = new Intl.NumberFormat("ja-JP").format(parseInt(minPrice - cartTotalSum)) + "円";

  let isReachPurchasePrice;

  if (Number(cartTotalSum) >= Number(minPrice)) {
    //購入可能金額に届いているとき
    remainPriceText.style.display = "none";
    isReachPurchasePrice = true;
  } else {
    //購入可能金額に届いていないとき
    remainPriceText.style.display = "block";
    isReachPurchasePrice = false;
  }

  return isReachPurchasePrice;
}

//チェックボックス状態変更時
function checkAllBoxes(checkBoxes, isReachPurchasePrice, cartButton) {
  const alertText = document.querySelector(".cart-recap .input_error"); //アラートテキスト
  let isAllChecked = true;

  // すべてのチェックボックスの状態を確認
  checkBoxes.forEach((checkbox) => {
    if (!checkbox.checked) {
      isAllChecked = false;
    }
  });


  if(document.querySelector('#deliver_date').value == '') {
    isAllChecked = false;
  }

  if(document.querySelector('#deliver_time').value == '') {
    isAllChecked = false;
  }

  if (isAllChecked) {
    // すべてチェックされているとき
    if (isReachPurchasePrice) {
      //最低購入金額を満たしている時
      cartButton.disabled = false; //カートボタン活性化
      alertText.style.visibility = "hidden"; //アラート非表示
    } else {
      cartButton.disabled = true; //カートボタン非活性化
      alertText.style.visibility = "visible"; //アラート非表示
    }
  } else {
    //チェックされていない項目があるとき
    cartButton.disabled = true; //カートボタン非活性化
    alertText.style.visibility = "visible"; //アラート表示
  }
}

//select,input情報をセッションストレージに格納
function registerForSettionStorage(prefSelectBox, citySelectBox, checkBoxes) {
  sessionStorage.setItem("prefecture", prefSelectBox.value);
  sessionStorage.setItem("city", citySelectBox.value);
  checkBoxes.forEach((checkbox, index) => {
    sessionStorage.setItem(`checkbox${index}`, checkbox.checked.toString());
  });
}

//ページ再読み込み
function pageReload() {
  setTimeout(() => {
    location.reload();
  }, 1000);
}

//カートボタン非活性化(1秒間)
function cartButtonDisabled() {
  let cnt = 0;
  let intervalId = setInterval(() => {
    let cartButton = document.querySelector(".cart-recap__checkout");
    cartButton.disabled = true;
    cartButton.style.backgroundColor = "#a9a9a9";
    cnt++;
    if (cnt === 1000) {
      clearInterval(intervalId);
    }
  }, 1);
}



//締め切り時間を過ぎたらページをリロード
var hasReloaded = false;

document.getElementById('cartCheckout').addEventListener('click', async function(event) {

  event.preventDefault();

// 締め切り時間
  const deadlineHour = dead_line_time.split(':')[0];
  const dateFromTime = new Date(`${dead_line_date}T${dead_line_time}:00Z`);
  const minutes = dateFromTime.getMinutes(); // 分を取得
  const deadlineMinutes = minutes + 1;// 1分を加える


  // 最短配達日を取得
  const selectableDate = new Date(dead_line_date).getDate();


  // 選択されている日付を取得
  const dateValue = document.querySelector('#deliver_date').value;
  const selectedDay = new Date(dateValue).getDate();
  // 選択されている時間を取得
  const timeValue = document.getElementById('deliver_time').value;

  var now = new Date();
  var deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), deadlineHour, deadlineMinutes, 0); // 時間を設定


  // お届け日が空欄の場合、アラート表示
  if(dateValue === '') {
    event.preventDefault();
    alert('お届け希望日を選択してください。');

    return false;
  }

  // お届け時間が空欄の場合、アラート表示
  if(timeValue === '') {
    event.preventDefault();
    alert('お届け時間帯を選択してください。');

    return false;
  }

  await setCartAttribute();


  // if (selectedDay === Number(selectableDate) && now >= deadline && !hasReloaded) {
  //   // 選択した日が最短配達日で、締切り時間を過ぎている場合
  //   event.preventDefault();
  //   alert('締切り時間を過ぎています。カートを更新してください。');
  //   location.reload();
  //   hasReloaded = true; // リロードが行われたことを記録
  // }

});


// CartAttributeをセットする
async function setCartAttribute(){
  const deliver_date = document.querySelector('#deliver_date').value != '' ? document.querySelector('#deliver_date').value : '指定なし';
  const deliver_time = document.getElementById('deliver_time').value != '' ? document.getElementById('deliver_time').value : '指定なし';

  console.log({ deliver_date });

  // // 1つ目のLineItemのIDを取得
  // const lineItem = document.querySelector('.line-item').getAttribute('data-lineid');

  document.querySelector('[name="checkout"]').classList.add('disabled');


  const cartItems = await fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
    return  response.json(); // 応答の JSON を解析して返す
  });
  console.log(cartItems);

  async function updateItems() {
    const results = [];
    console.log(cartItems.items);
    const is_setItem = cartItems.items.find((item) => {
      // item.propertiesが{}でない場合は、配送日時が設定されていると判断する
      console.log(Object.keys(item.properties).length)
      return Object.keys(item.properties).length > 0;
    });

    const item = is_setItem ? is_setItem : cartItems.items[0];

    console.log({ is_setItem });

      console.log({ deliver_date });
      console.log({ deliver_time });

      if (deliver_time !== '指定なし' && deliver_date !== '指定なし') {
        const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': item.key,
            'quantity': item.quantity,
            'properties': {
              'お届け希望日': deliver_date,
              'お届け時間帯': deliver_time,
            }
          })
        });

        const result = await res.json(); // fetchの結果を待ってから結果を取得
        results.push(result);
      } else {
        results.push('not change');
      }
    // }

    return results;
  }


  const body = JSON.stringify(
    {
      attributes: {
      'Delivery-Date': deliver_date,
      'Delivery-Time': deliver_time,
      }
    }
  );

  // Cart Attribute を更新
  const result =  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body });


    // 	LinePropertyを更新
    updateItems()
    .then(()=>{
      setTimeout(()=>{
        document.querySelector('[name="checkout"]').classList.remove('disabled');
        window.location.href = '/checkout';
      },500);
    })
    .catch((error) => {
      // エラーハンドリング
      setTimeout(()=>{
        document.querySelector('[name="checkout"]').classList.remove('disabled');
      },500)
      console.error(error);
    });
}

document.querySelector('#deliver_time').addEventListener('change',async ()=>{
  // await setCartAttribute();
})

/**
 * 追加配送設定されている場合、指定の日時で配送日時を変更する
 *
 */

document.getElementById('deliver_date').addEventListener('change', async function(event) {
  const value = event.target.value;
  let boolAddDeliverTime = false;

  // await setCartAttribute();

  add_deliver_time.forEach((item) => {
    if(item.dates && item.dates.includes(value)) {
      changeTimes(item.times);
      boolAddDeliverTime = true;
    }
  });
  if(!boolAddDeliverTime) {
    changeTimes(default_deliver_time);
  }

});

function changeTimes(times) {
  const timeSelect = document.getElementById('deliver_time');
  timeSelect.innerHTML = '';
  times.forEach((time) => {
    const option = document.createElement('option');
    option.value = time.value;
    option.innerText = time.label;
    timeSelect.appendChild(option);
  });
}
